import {useTheme} from '@material-ui/core/styles';

/**
 * Injects Swagger UI dark-mode overrides as an inline <style> tag,
 * but ONLY when the active theme is dark (theme.palette.type === 'dark').
 * In light mode this component renders nothing.
 *
 * Place this component inside the UnifiedThemeProvider tree so it has
 * access to the current theme context.
 */

const swaggerDarkCss = `
  /* Swagger UI – input field overrides for dark theme */
  .swagger-ui input[type=text],
  .swagger-ui input[type=email],
  .swagger-ui input[type=password],
  .swagger-ui input[type=search],
  .swagger-ui input[type=file],
  .swagger-ui textarea,
  .swagger-ui select {
    background-color: #0f1d47 !important;
    color: #c8d4f0 !important;
    border: 1px solid #1a2a6e !important;
    border-radius: 4px;
  }

  .swagger-ui input[type=text]:focus,
  .swagger-ui input[type=email]:focus,
  .swagger-ui input[type=password]:focus,
  .swagger-ui input[type=search]:focus,
  .swagger-ui textarea:focus {
    border-color: #EF6D00 !important;
    outline: none !important;
    box-shadow: 0 0 0 2px rgba(239, 109, 0, 0.2) !important;
  }

  .swagger-ui input[type=text]::placeholder,
  .swagger-ui input[type=email]::placeholder,
  .swagger-ui input[type=password]::placeholder,
  .swagger-ui input[type=search]::placeholder,
  .swagger-ui textarea::placeholder {
    color: #5a6a94 !important;
    opacity: 1 !important;
  }
`;

export const SwaggerDarkStyles = () => {
  const theme = useTheme();
  if (theme.palette.type !== 'dark') {
    return null;
  }
  // eslint-disable-next-line react/no-danger
  return <style dangerouslySetInnerHTML={{ __html: swaggerDarkCss }}/>;
};
